export enum SlidersTypeEnum {
  Pained,
  Transparent
}
